import styled from 'styled-components';

export const StyledNfzLoginForm = styled.form`
   display: flex;
   flex-direction: column;
   gap: 8px;
`;

StyledNfzLoginForm.displayName = 'StyledNfzLoginForm';
